<template>
  <van-nav-bar
    title="学生住宿信息确认表"
     left-text="退出登录"
    
    @click-left="onClickOut"
  />
  <van-divider content-position="left">学生信息</van-divider>
  <div class="divcenter">
  <van-row :gutter="10">
    <van-col span="10">学号：{{ ruleForm.datas.student_No }}</van-col>
    <van-col span="14">姓名：{{ ruleForm.datas.student_Name }}</van-col>
  </van-row>
  <van-row :gutter="10">
    <van-col span="10">拼音码: {{ ruleForm.datas.student_Name_Spell }}</van-col>
    <van-col span="14">身份证号：{{ ruleForm.datas.student_IDnumber }}</van-col>
  </van-row>
  <van-row :gutter="10">
    <van-col span="10">性别： {{ ruleForm.datas.student_Sex }}</van-col>
    <van-col span="14">生日：{{ ruleForm.datas.student_Birthday }}</van-col>
  </van-row>
  <van-row :gutter="10">
    <van-col span="10">学生类型: {{ ruleForm.datas.student_Type }}</van-col>
    <van-col span="14">手机号：{{ ruleForm.datas.student_Mobile }}</van-col>
  </van-row>
  <van-row :gutter="10">
    <van-col span="10">年级： {{ ruleForm.datas.student_Grade }}</van-col>
    <van-col span="14">学制：{{ ruleForm.datas.student_Years }}</van-col>
  </van-row>
  <van-row :gutter="10">
    <van-col span="10">民族: {{ ruleForm.datas.student_mz }}</van-col>
    <van-col span="14">政治面貌：{{ ruleForm.datas.student_Zzmm }}</van-col>
  </van-row>
  <van-row :gutter="10">
    <van-col span="10"
      >入学时间： {{ ruleForm.datas.student_Entrance_DateStr }}</van-col
    >
    <van-col span="14"
      >毕业时间：{{ ruleForm.datas.student_Leave_DateStr }}</van-col
    >
  </van-row>
  <van-row :gutter="10">
    <van-col span="10">邮箱： {{ ruleForm.datas.student_Email }}</van-col>
    <van-col span="14">院系：{{ ruleForm.datas.student_Dept }}</van-col>
  </van-row>
  <van-row :gutter="10">
    <van-col span="10">专业： {{ ruleForm.datas.student_Specialty }}</van-col>
    <van-col span="14">班级：{{ ruleForm.datas.student_Class }}</van-col>
  </van-row>
  </div>
  <van-divider content-position="left">家庭信息</van-divider>
  <div class="divcenter">
  <van-row :gutter="10">
    <van-col span="10"
      >父/母姓名: {{ ruleForm.datas.student_Home_Parents }}</van-col
    >
    <van-col span="14">籍贯：{{ ruleForm.datas.student_NativePlace }}</van-col>
  </van-row>
  <van-row :gutter="10">
    <van-col span="10"
      >家庭电话： {{ ruleForm.datas.student_Home_Mobile }}</van-col
    >
    <van-col span="14">邮编：{{ ruleForm.datas.student_Home_Code }}</van-col>
  </van-row>
  <van-row>
    <van-col span="24"
      >家庭地址： {{ ruleForm.datas.student_Home_address }}</van-col
    >
  </van-row>
  </div>
  <van-divider content-position="left">住宿信息</van-divider>
   <div class="divcenter">
  <van-row :gutter="10">
    <van-col span="10"
      >公寓： {{ ruleForm.datas.student_BuildingName }}</van-col
    >
    <van-col span="14">房间：{{ ruleForm.datas.student_Room }} 房间</van-col>
  </van-row>
  <van-row :gutter="10">
    <van-col span="10"
      >床位： {{ ruleForm.datas.student_Cwname }} 号床位</van-col
    >
  </van-row>
  <van-row>
    <van-col span="24">备注：{{ ruleForm.datas.student_Memo }}</van-col>
  </van-row>
  </div>
  <van-divider content-position="left">您的同房间舍友</van-divider>

  <van-list
    v-model="ruleForm.Roomlist"
    :finished="finished"
    finished-text="没有更多了"  
  >
    <van-row class="van-rowtitle">
      <van-col span="4">床位号</van-col>
      <van-col span="5">姓名</van-col>
      <van-col span="5">民族</van-col>
      <van-col span="5">专业</van-col>
      <van-col span="5">生活习惯</van-col>
    </van-row>
    <van-row  v-for="item in ruleForm.Roomlist"   :key="item">
      <van-col span="4">{{item.cw_Name}} {{item.cw_type}}</van-col>
      <van-col span="5">{{item.student_Name}}</van-col>
      <van-col span="5">{{item.student_mz}}</van-col>
      <van-col span="5">{{item.zsfp_TypeName}}</van-col>
      <van-col span="5">{{item.student_Habits}}</van-col>
    </van-row>
  </van-list>
</template>
<style scoped>
.van-grid-item {
  text-align: left;
  padding-left: 10px;
}
.divcenter {
  border: 1px solid #059490;
  margin: auto 20px;
}

.van-list{
 border: 1px solid #059490;
  margin: 20px 20px;
}
.van-rowtitle {  
  font-weight: bold;
}
.van-checkbox {
  padding: 5px;
}
.van-col {
  color: var(--van-grid-item-text-color);
  font-size: var(--van-grid-item-text-font-size);
  line-height: 1.5;
  word-break: break-all;
  padding: 10px 5px;
  text-align: left;
}
.van-collapse-item__content {
  padding: 0px;
}
</style>
<script>
import { Toast } from "vant";
import { reactive } from "vue";
import { getStudent } from "../../http/api.ts";
import { getRoomStudent } from "../../http/api.ts";
import Route from "../../router/index";
export default {
  setup() {
    let imgs = reactive("../../images/logo.png");
    let ruleForm = reactive({
      datas: [],
      Roomlist: [],
    });
    let dataFun = async () => {
      await getStudent().then((res) => {
        ruleForm.datas = res.datas;
      });
      await getRoomStudent(ruleForm.datas.student_Room_Serial,ruleForm.datas.student_Grade).then((res) => {
        ruleForm.Roomlist = res.datas;
      });
    };
    dataFun();
    return {
      ruleForm,
      imgs,
    };
  },
  methods: {
    onSubmit(ruleForm) {
      Toast.fail(ruleForm.student_Memo);
    },onClickOut(){
      Toast.success("退出登录成功！");
      localStorage.removeItem("userToken");
      localStorage.removeItem("username");
      setTimeout(function () {
        Route.push("/m?tmsite="+Math.random());
      }, 1000);
    }
  },
};
</script>